module.exports = __webpack_public_path__ + "img/image5x2.54b77d25.jpg";